import { FC } from 'react';
import styled from 'styled-components';

import { MpLink } from 'shared/ui/MpLink';
import { MpOl } from 'shared/ui/MpOl';
import { MpText } from 'shared/ui/MpText';

const ImgStyled = styled.img`
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 312px;
		margin: 16px 0 12px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 425px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		margin: 16px 0 12px 16px;
	}
`;

export const iSpringInstruction: FC = () => (
	<MpOl style={{ gap: `12px` }}>
		<li>
			<MpText>Нажмите кнопку «Подключить»</MpText>
		</li>
		<li>
			<MpText>Выдайте доступ к вашим данным, нажав кнопку «Дать доступ»</MpText>
		</li>
		<li>
			<MpText>
				Заведения подключены. Теперь ваши сотрудники могут проходить обучение на платформе
				ISpring,&nbsp;перейдя&nbsp;по&nbsp;ссылке в личном кабинете Dodo IS (Обучение и соц.сети → Обучение →
				iSpring)
			</MpText>
			<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/ispring/instruction-1-png' />
		</li>
		<li>
			<MpText>Если подразделения не подключились, повторите попытку, нажав кнопку «Повторить подключение»</MpText>
			<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/ispring/instruction-2-png' />
		</li>
		<li>
			<MpText>
				Если у вас возникли сложности при работе, обратитесь в техническую поддержку
				{` `}
				<MpLink internal text='podorojnik@dodois.io' url='mailto:podorojnik@dodois.io' />.
			</MpText>
		</li>
	</MpOl>
);
// eslint-disable-next-line @typescript-eslint/naming-convention
export const iSpringInstruction_eng: FC = () => (
	<MpOl style={{ gap: `12px` }}>
		<li>
			<MpText>Click the &quot;Connect&quot; button</MpText>
		</li>
		<li>
			<MpText>Grant access to your data by clicking the &quot;Grant Access&quot; button</MpText>
		</li>
		<li>
			<MpText>
				Establishments are connected. Now your employees can undergo training on the iSpring platform by
				following the link in the Dodo IS personal account (Training and Social Networks → Training → iSpring)
			</MpText>
			<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/ispring/instruction-1-png' />
		</li>
		<li>
			<MpText>
				If departments are not connected, try again by clicking the &quot;Retry Connection&quot; button
			</MpText>
			<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/ispring/instruction-2-png' />
		</li>
		<li>
			<MpText>
				If you encounter difficulties, contact technical support
				{` `}
				<MpLink internal text='podorojnik@dodois.io' url='mailto:podorojnik@dodois.io' />.
			</MpText>
		</li>
	</MpOl>
);
